import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import InboxPageContent from '../components/page/InboxPageContent';
import Page from '../components/page/Page';
import { useAuth } from '../context/AuthContext';
import { BASE_SEARCH_PATH } from '../utils/search';
import { redirectToLogin } from '../utils/url';

const InboxDashboard = dynamic(
  () => import('../components/inbox/InboxDashboard'),
  { ssr: false },
);

const Inbox: React.FC = () => {
  const { currentUser, isLoadingUser } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (isLoadingUser) {
      return;
    }

    if (currentUser == null) {
      void redirectToLogin(router);
    } else if (currentUser.applicant == null) {
      void router.replace(BASE_SEARCH_PATH);
    }
  }, [currentUser, isLoadingUser, router]);

  if (isLoadingUser || !currentUser?.applicant) {
    return null;
  }

  return (
    <Page title="Message">
      <InboxPageContent hideFooter hideMessagesContainer>
        <div className="sticky size-full overflow-hidden">
          <InboxDashboard reload={router.reload} />
        </div>
      </InboxPageContent>
    </Page>
  );
};

export default Inbox;
